import { render } from "./main.vue?vue&type=template&id=04356b22"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import exportComponent from "D:\\srv\\vhost\\f-cat-app\\frontend\\musicbizz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__